module.exports = __webpack_public_path__ + "images/google-authentication-50938a41be9730146b7b6a47cdfb2f4e.jpg";